import React from 'react';

export interface CacheResults {
  /* The cache stores anything and verifies nothing, so what comes out is
     untyped: the caller asserts what it put under its own key. Empty for a key
     never written, and null for one that has been reset */
  getCacheResultValue: (key: string) => unknown;
  setCacheResultValue: (
    key: string,
    value: unknown,
    reRenderAfterUpdate?: boolean
  ) => void;
  resetCacheResultValue: (key: string) => void;
}

export default React.createContext<CacheResults>({
  getCacheResultValue: () => null,
  setCacheResultValue: () => {},
  resetCacheResultValue: () => {}
});
